/*import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;*/
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RegistrationPage from './pages/RegistrationPage';
import SuccessPage from "./pages/SuccessPage";

import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import LoginPage from './pages/LoginPage';
import SwimmersAdminPanel from './components/admin/SwimmersAdminPanel';
import DistanceRegistrationsPage from './pages/DistanceRegistrationsPage';
//import SwimmersListPage from './pages/SwimmersListPage';
// import Navbar from './components/Navbar';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

function App() {

    return (

            <div className="min-h-screen bg-gray-50">
                {/*<Navbar />*/}

                <main className="container mx-auto py-8 px-4">
                    <Routes>
                        <Route path="/" element={<RegistrationPage />} />
                        <Route path="/registration" element={<SuccessPage />} >
                        <Route path=":id" element={<SuccessPage />} />
                        </Route>

                        {/* Публичные маршруты */}
                        <Route path="/loginsw" element={<LoginPage />} />

                        {/* Защищенные маршруты */}
                        {/*<Route path="/admin/swimmers" element={*/}
                        {/*    <PrivateRoute>*/}
                        {/*        <AdminRoute>*/}
                        {/*            <SwimmersAdminPanel />*/}
                        {/*        </AdminRoute>*/}
                        {/*    </PrivateRoute>*/}
                        {/*} />*/}
                        <Route path="/admin/swimmers" element={
                            <PrivateRoute>
                                <SwimmersAdminPanel />
                            </PrivateRoute>
                        } />
                        <Route path="/admin/distance-registrations"
                               element={
                                   <PrivateRoute>

                                           <DistanceRegistrationsPage />

                                   </PrivateRoute>
                               } />
                        {/* Перенаправление */}
                        {/*<Route path="*" element={<Navigate to="/login" />} />*/}
                        {/*<Route path="/registration" element={<RegistrationPage />} />*/}
                        {/*<Route path="/swimmers" element={<SwimmersListPage />} />*/}
                    </Routes>
                </main>
            </div>

    );
}

export default App;
